require("../styles/bootstrap.min.css");
require("../styles/mdb.css");
//require("../styles/mdb.lite.css");
//richtig einbinden!
require("../../node_modules/@agileis/fontawesome-pro/css/all.min.css");
require("../../node_modules/cookieconsent/build/cookieconsent.min.css");



require("jquery");
require("./bootstrap.min.js");
require("./popper.min.js");
require("./vendor/jquery.easing.js");
require("./vendor/velocity.min.js");
require("./vendor/chart.js");
window.WOW = require("./vendor/wow.js").WOW;
require("./scrolling-navbar.js");
require("./vendor/waves.js");
require("./forms-free.js");
require("./vendor/enhanced-modals.js");
require("./default-file-input.js");
require("./custom.js");
require("./cookieconsent.js");